<template>
  <div>
    <!-- Barra superior delgada: marca + hamburguesa + usuario. Sticky para que no
         solape el contenido (ocupa espacio en el flujo) y siga visible al hacer scroll. -->
    <b-navbar small type="dark" variant="dark" class="app-topbar" sticky>
      <b-navbar-nav>
        <b-button variant="dark" class="menu-toggle" @click="sidebarVisible = true" aria-label="Menú">
          <span class="navbar-toggler-icon"></span>
        </b-button>
      </b-navbar-nav>
      <b-navbar-brand class="mx-auto mx-lg-0" @click="go('/dashboard')">
        <img src="@/assets/img/logo_white.png" style="max-height: 32px;" />
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto flex-row align-items-center">
        <b-nav-item-dropdown right no-caret>
          <template #button-content>
            <span class="d-none d-sm-inline">{{ tenant }}</span>
            <b-icon-person-circle class="d-sm-none"></b-icon-person-circle>
          </template>
          <b-dropdown-item @click="go('/selecttenant?override=true')">Cambiar espacio</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button @click="logout">Salir</b-dropdown-item-button>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>

    <!-- Menú lateral deslizable (off-canvas), responsivo en escritorio y móvil. -->
    <b-sidebar
      id="app-sidebar"
      v-model="sidebarVisible"
      title="Menú"
      backdrop
      shadow
      width="280px"
      no-header-close
      bg-variant="dark"
      text-variant="light"
      body-class="app-sidebar-body"
    >
      <template #header>
        <div class="d-flex align-items-center justify-content-between w-100 px-2 py-2">
          <img src="@/assets/img/logo_white.png" style="max-height: 30px;" />
          <b-button size="sm" variant="outline-light" @click="sidebarVisible = false">✕</b-button>
        </div>
      </template>

      <b-nav vertical class="app-sidebar-nav">
        <b-nav-item @click="go('/dashboard')">Resumen general</b-nav-item>
        <b-nav-item @click="go('/sucursales')">Sucursales</b-nav-item>
        <b-nav-item @click="go('/customers')">Clientes</b-nav-item>
        <b-nav-item v-if="hasPermission('rrn:central:loyalty:getProgram')" @click="go('/loyaltyprograms')">Lealtad</b-nav-item>
        <b-nav-item v-if="execEnabled" @click="go('/executive')">Ejecutivo</b-nav-item>

        <!-- Configuración -->
        <div class="sidebar-group">
          <b-button v-b-toggle.g-config block class="group-toggle">Configuración</b-button>
          <b-collapse id="g-config">
            <b-nav vertical class="group-items">
              <b-nav-item @click="go('/config/features')">Funcionalidades</b-nav-item>
              <b-nav-item @click="go('/config/channels')">Canales y modalidades</b-nav-item>
            </b-nav>
          </b-collapse>
        </div>

        <!-- Marketing -->
        <div class="sidebar-group">
          <b-button v-b-toggle.g-marketing block class="group-toggle">Marketing</b-button>
          <b-collapse id="g-marketing">
            <b-nav vertical class="group-items">
              <b-nav-item @click="go('/marketing/promotions')">Promociones</b-nav-item>
              <b-nav-item @click="go('/marketing/referrals')">Referidos</b-nav-item>
              <b-nav-item @click="go('/marketing/attribution')">Atribución</b-nav-item>
              <b-nav-item @click="go('/marketing/notifications')">Notificaciones</b-nav-item>
              <b-nav-item @click="go('/marketing/qr-descargas')">QR de descarga</b-nav-item>
            </b-nav>
          </b-collapse>
        </div>

        <!-- Catálogos -->
        <div class="sidebar-group">
          <b-button v-b-toggle.g-catalogos block class="group-toggle">Catálogos</b-button>
          <b-collapse id="g-catalogos">
            <div class="group-items">
              <div class="group-subheader">Productos vendibles</div>
              <b-nav vertical>
                <b-nav-item @click="go('/groups')">Grupos</b-nav-item>
                <b-nav-item @click="go('/products')">Productos</b-nav-item>
                <b-nav-item @click="go('/personalizations')">Personalizadores</b-nav-item>
                <b-nav-item @click="go('/product-extra-groups')">Grupos de Extras</b-nav-item>
              </b-nav>
              <div class="group-subheader">Generales</div>
              <b-nav vertical>
                <b-nav-item v-if="hasPermission('rrn:central:floors:list')" @click="go('/floors')">Mesas</b-nav-item>
                <b-nav-item @click="go('/preparationareas')">Áreas de Preparación</b-nav-item>
                <b-nav-item @click="go('/discounts')">Descuentos</b-nav-item>
                <b-nav-item v-if="hasPermission('rrn:central:loyalty:getProgram')" @click="go('/loyaltyprograms')">Programas de Lealtad</b-nav-item>
                <b-nav-item @click="go('/loyalty/tiers')">Niveles de Lealtad</b-nav-item>
                <b-nav-item @click="go('/loyalty/benefits')">Beneficios</b-nav-item>
                <b-nav-item @click="go('/paymentmethods')">Formas de pago</b-nav-item>
                <b-nav-item @click="go('/waiters')">Meseros</b-nav-item>
                <b-nav-item @click="go('/paydesk/movements')">Movimientos de Caja</b-nav-item>
                <b-nav-item @click="go('/areas')">Areas</b-nav-item>
                <b-nav-item @click="go('/tax-management')">Configuración de Impuestos</b-nav-item>
              </b-nav>
              <div class="group-subheader">Insumos y almacén</div>
              <b-nav vertical>
                <b-nav-item @click="go('/supplycategories')">Categorías de insumos</b-nav-item>
                <b-nav-item @click="go('/supplies')">Insumos</b-nav-item>
                <b-nav-item @click="go('/supply/lists')">Listas de Insumos</b-nav-item>
                <b-nav-item @click="go('/providers')">Proveedores</b-nav-item>
              </b-nav>
            </div>
          </b-collapse>
        </div>

        <!-- Plataformas -->
        <div class="sidebar-group" v-if="showPlatformsGroup">
          <b-button v-b-toggle.g-plataformas block class="group-toggle">Plataformas</b-button>
          <b-collapse id="g-plataformas">
            <div class="group-items">
              <template v-if="hasPermission('rrn:central:platforms:uber')">
                <div class="group-subheader">Uber</div>
                <b-nav vertical>
                  <b-nav-item @click="go('/uber/stores')">Sucursales/Stores</b-nav-item>
                  <b-nav-item @click="go('/uber')">Creador de Menus</b-nav-item>
                  <b-nav-item @click="go('/uber/menu/viewer')">Visor de Menus</b-nav-item>
                  <b-nav-item @click="go('/uber/menu/copy')">Copia de Menus</b-nav-item>
                  <b-nav-item @click="go('/uber/onboarding')">Onboarding (Alta de tiendas)</b-nav-item>
                </b-nav>
              </template>
              <template v-if="hasPermission('rrn:central:platforms:rappi')">
                <div class="group-subheader">Rappi</div>
                <b-nav vertical>
                  <b-nav-item @click="go('/rappi/stores')">Sucursales/Stores</b-nav-item>
                  <b-nav-item @click="go('/rappi/menu')">Creador de Menus</b-nav-item>
                  <b-nav-item @click="go('/rappi/onboarding')">Onboarding (Alta de tiendas)</b-nav-item>
                </b-nav>
              </template>
              <div class="group-subheader" v-if="platformMenuAccess || platformStoreAccess || platformOrderAccess">Plataformas</div>
              <b-nav vertical>
                <b-nav-item v-if="platformMenuAccess" :to="{ name: 'platform-overview' }" exact @click="sidebarVisible = false">Dashboard</b-nav-item>
                <b-nav-item v-if="platformStoreAccess" :to="{ name: 'platform-stores' }" @click="sidebarVisible = false">Tiendas / Configuración</b-nav-item>
                <b-nav-item v-if="platformMenuAccess" :to="{ name: 'platform-builder' }" @click="sidebarVisible = false">Constructor de Menús</b-nav-item>
                <b-nav-item v-if="platformMenuAccess" :to="{ name: 'platform-menu-editor' }" @click="sidebarVisible = false">Editor de Menú</b-nav-item>
                <b-nav-item v-if="platformOrderAccess" :to="{ name: 'platform-orders' }" @click="sidebarVisible = false">Órdenes</b-nav-item>
                <b-nav-item v-if="platformMenuAccess" :to="{ name: 'platform-menus' }" @click="sidebarVisible = false">Menus</b-nav-item>
                <b-nav-item v-if="platformMenuAccess" :to="{ name: 'platform-categories' }" @click="sidebarVisible = false">Categorías</b-nav-item>
                <b-nav-item v-if="platformMenuAccess" :to="{ name: 'platform-items' }" @click="sidebarVisible = false">Artículos</b-nav-item>
                <b-nav-item v-if="platformMenuAccess" :to="{ name: 'platform-modifiers' }" @click="sidebarVisible = false">Modificadores</b-nav-item>
              </b-nav>
            </div>
          </b-collapse>
        </div>

        <!-- Reportes -->
        <div class="sidebar-group">
          <b-button v-b-toggle.g-reportes block class="group-toggle">Reportes</b-button>
          <b-collapse id="g-reportes">
            <b-nav vertical class="group-items">
              <b-nav-item @click="go('/inventory/report')">Cambio de Inventario</b-nav-item>
              <b-nav-item @click="go('/turnos')">Turnos</b-nav-item>
              <b-nav-item @click="go('/dashboard')">Resumen General</b-nav-item>
              <b-nav-item v-if="hasPermission('rrn:central:reports:dailyReport')" @click="go('/report/daily')">Venta Diaria</b-nav-item>
              <b-nav-item v-if="hasPermission('rrn:central:reports:dailyByArea')" @click="go('/report/daily/area')">Venta Diaria Por Área</b-nav-item>
              <b-nav-item v-if="hasPermission('rrn:central:reports:productPopularity')" @click="go('/report/popularidad')">Venta Por Artículo/Popularidad</b-nav-item>
              <b-nav-item v-if="hasPermission('rrn:central:reports:waiterPerformance')" @click="go('/report/waiter/performance')">Desempeño de Meseros</b-nav-item>
              <b-nav-item v-if="hasPermission('rrn:central:reports:tipDistributions')" @click="go('/report/tips/distribution')">Reparto de Propinas — Detalle</b-nav-item>
              <b-nav-item v-if="hasPermission('rrn:central:reports:tipNetByWaiter')" @click="go('/report/tips/per-waiter')">Propina Neta por Mesero</b-nav-item>
              <b-nav-item v-if="hasPermission('rrn:central:reports:tipRate')" @click="go('/report/tips/rate')">Tasa de Propina sobre Ventas</b-nav-item>
              <b-nav-item @click="go('/report/recipe-consumption')">Consumo de Recetas</b-nav-item>
              <b-nav-item @click="go('/report/almacen/general')">Reporte Diario Almacén General</b-nav-item>
              <b-nav-item @click="go('/ticket/query')">Buscar Cuentas</b-nav-item>
              <b-nav-item @click="go('/report/date')">Más Reportes</b-nav-item>
            </b-nav>
          </b-collapse>
        </div>

        <!-- Inventarios -->
        <div class="sidebar-group">
          <b-button v-b-toggle.g-inventarios block class="group-toggle">Inventarios</b-button>
          <b-collapse id="g-inventarios">
            <div class="group-items">
              <b-nav vertical>
                <b-nav-item @click="go('/inventory/report')">Cambio de Inventario</b-nav-item>
                <b-nav-item @click="go('/inventario/ajustes')">Conteo Físico</b-nav-item>
                <b-nav-item @click="go('/compras')">Compras</b-nav-item>
                <b-nav-item @click="go('/inventory/suggested-po')">Orden de Compra Sugerida</b-nav-item>
                <b-nav-item @click="go('/movimientos')">Movimientos de Inventario</b-nav-item>
                <b-nav-item @click="go('/stock-locations')">Ubicaciones de Inventario</b-nav-item>
                <b-nav-item @click="go('/cost-management')">Gestión de Costos</b-nav-item>
              </b-nav>
              <div class="group-subheader">Análisis</div>
              <b-nav vertical>
                <b-nav-item v-if="hasPermission('rrn:central:stock:get')" @click="go('/existencias')">Existencias</b-nav-item>
                <b-nav-item @click="go('/stock/analyze')">Análisis de Inventario</b-nav-item>
              </b-nav>
              <div class="group-subheader">Producción</div>
              <b-nav vertical>
                <b-nav-item @click="go('/boms')">Recetas de Producción</b-nav-item>
                <b-nav-item @click="go('/manufacturingorders')">Ordenes de Produccion</b-nav-item>
              </b-nav>
              <div class="group-subheader">Roadmap</div>
              <b-nav vertical>
                <b-nav-item href="https://rigada.notion.site/11f6495b9b1f80a2bcefee07162023f7?v=121ce6467efb401c84dc6f92dd4e3c94" target="_blank">Roadmap Inventarios</b-nav-item>
              </b-nav>
            </div>
          </b-collapse>
        </div>

        <!-- Tickets -->
        <div class="sidebar-group">
          <b-button v-b-toggle.g-tickets block class="group-toggle">Tickets</b-button>
          <b-collapse id="g-tickets">
            <b-nav vertical class="group-items">
              <b-nav-item @click="go('/ticket/query')">Buscar</b-nav-item>
            </b-nav>
          </b-collapse>
        </div>

        <!-- Usuarios -->
        <div class="sidebar-group" v-if="hasPermission('rrn:central:users:getUser')">
          <b-button v-b-toggle.g-usuarios block class="group-toggle">Usuarios</b-button>
          <b-collapse id="g-usuarios">
            <b-nav vertical class="group-items">
              <b-nav-item @click="go('/userGroups')">Grupos</b-nav-item>
              <b-nav-item @click="go('/signup')">Usuarios</b-nav-item>
            </b-nav>
          </b-collapse>
        </div>

        <!-- Facturación -->
        <div class="sidebar-group">
          <b-button v-b-toggle.g-facturacion block class="group-toggle">Facturación</b-button>
          <b-collapse id="g-facturacion">
            <b-nav vertical class="group-items">
              <b-nav-item @click="go('/facturas')">Mis Facturas</b-nav-item>
              <b-nav-item @click="go('/factura')">Nueva Factura</b-nav-item>
              <b-nav-item @click="go('/facturacion/clientes')">Clientes</b-nav-item>
            </b-nav>
          </b-collapse>
        </div>
      </b-nav>

      <div class="sidebar-footer">
        <div class="text-muted small px-3">Espacio: {{ tenant }}</div>
        <b-button variant="outline-danger" size="sm" block class="mt-1" @click="logout">Salir</b-button>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import axios from "axios";
import featuresService from "@/services/featuresService";

export default {
  name: "Nav",
  data() {
    return {
      sidebarVisible: false,
      // Flag reports.executive (propuesta integral Fase 6): condiciona el menú Ejecutivo.
      execFeatureEnabled: false
    };
  },
  computed: {
    tenant() {
      return this.$store.getters["server/tenant"];
    },
    execEnabled() {
      return this.execFeatureEnabled && this.hasPermission("rrn:central:reports:exec");
    },
    // Las rutas /platform/* ya exigen permiso en el backend, así que el menú
    // esconde lo que devolvería 403 en vez de mostrarlo y fallar al entrar.
    platformMenuAccess() {
      return this.hasPermission("rrn:central:platform:menu:read");
    },
    platformStoreAccess() {
      return this.hasPermission("rrn:central:platform:store:read");
    },
    platformOrderAccess() {
      return this.hasPermission("rrn:central:platform:order:read");
    },
    showPlatformsGroup() {
      return (
        this.hasPermission("rrn:central:platforms:uber") ||
        this.hasPermission("rrn:central:platforms:rappi") ||
        this.platformMenuAccess ||
        this.platformStoreAccess ||
        this.platformOrderAccess
      );
    }
  },
  created() {
    featuresService.getAll()
      .then((res) => {
        const f = res.data && res.data.features && res.data.features["reports.executive"];
        this.execFeatureEnabled = !!(f && f.enabled);
      })
      .catch(() => { this.execFeatureEnabled = false; });
  },
  methods: {
    logout() {
      localStorage.removeItem("user-token");
      localStorage.removeItem("user-token-time");
      axios.defaults.headers.common["Authorization"] = "Bearer ";
      this.$router.push("/").catch(() => {});
    },
    // Navega y cierra el menú lateral (útil sobre todo en móvil).
    go(path) {
      this.sidebarVisible = false;
      this.$router.push(path).catch(() => {});
    },
    navigateTo(path) {
      // Compatibilidad hacia atrás por si alguna vista invoca este método.
      this.go(path);
    }
  }
}
</script>

<style scoped>
.app-topbar {
  z-index: 1030;
}
.menu-toggle {
  border: none;
  padding: 0.25rem 0.5rem;
}
.b-navbar-brand,
.navbar-brand {
  cursor: pointer;
}
/* Tema oscuro para igualar la barra de navegación (b-navbar variant="dark"). */
.app-sidebar-nav >>> .nav-item .nav-link,
.app-sidebar-nav .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.85);
  padding: 0.4rem 1rem;
}
.app-sidebar-nav .nav-item .nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}
.sidebar-group {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.group-toggle {
  text-align: left;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  padding: 0.5rem 1rem;
}
.group-toggle:hover,
.group-toggle:focus {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  box-shadow: none;
}
.group-items {
  padding-bottom: 0.25rem;
  background: rgba(0, 0, 0, 0.2);
}
.group-items .nav-link {
  padding: 0.35rem 1rem 0.35rem 1.75rem;
  font-size: 0.9rem;
}
.group-subheader {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: rgba(255, 255, 255, 0.5);
  padding: 0.4rem 1rem 0.15rem 1.5rem;
}
.sidebar-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0.75rem;
}
</style>
